import { render } from "./UserDetailPermission.vue?vue&type=template&id=ea1173fc&scoped=true"
import script from "./UserDetailPermission.vue?vue&type=script&lang=js"
export * from "./UserDetailPermission.vue?vue&type=script&lang=js"

import "./UserDetailPermission.vue?vue&type=style&index=0&id=ea1173fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea1173fc"]])

export default __exports__